export enum EmailTemplateEnum {
  DEFAULT = "DEFAULT",
  VIU_COMMERCIAL = "VIU_COMMERCIAL"
}
